import { IArticlePreviewSchema } from '../../../repositories/valuation-b2b/entities/articles_list/ArticlePreviewSchema';
import { ICardItem } from '../../../components/Publications/types';

export const prepareContent = (content: IArticlePreviewSchema[]): ICardItem[] => {
  return content.map(item => {
    return {
      img: item.source.logoUrl,
      title: item.title,
      sourceName: item.source.displayName,
      id: item.articleId,
    };
  });
};
